export default __webpack_public_path__ + "images/b8e9d6a50aef1f9ffade3d8cba87c8b6.png";